module.exports = ".ssf-account-group__title {\n  font-size: 0.8rem;\n  font-weight: bold; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/accounts-groups/accounts-groups.component.scss
// module id = 611
// module chunks = 3